import { createStore } from 'satcheljs';
export default createStore('senderSubjectOption', {
    showSenderOnTopInListView: null,
})();
//# sourceMappingURL=store.js.map